import Api from './api';

const signUpRequest = (user, referer = '') => {
    return Api().post('/api/register?referer='+referer, user)
}

const signUpRequestByAdmin = async (user) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return await Api().post('/api/users', user, { headers: { Authorization: 'Bearer ' + access_token } })
}

const userListRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/users',  {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query
    })
}

const managerListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/managers/', { headers: { Authorization: 'Bearer ' + access_token } })
}

const salesStaffListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/sales-staff/', { headers: { Authorization: 'Bearer ' + access_token } })
}

const userRequest = (userId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/users/' + userId, { headers: { Authorization: 'Bearer ' + access_token } })
}

const userUpdateRequest = (userId, user) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/users/'+ userId, user, { headers: { Authorization: 'Bearer ' + access_token } })
}

const userUpdateByUserRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/user/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const userDepositUpdateRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/transactions/admin', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const userSettingsUpdateRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/settings', data, { headers: { Authorization: 'Bearer ' + access_token }, })
}

const userDetailsUpdateRequest = (data) => {
    console.log(data)
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/details', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const usersExportInExcelRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/excel/users', {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
    })
}

const loginAsOtherUser = (user) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/auth/admin', user,  { headers: { Authorization: 'Bearer ' + access_token } })
}

const requestAllUsers = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/users/all', { headers: { Authorization: 'Bearer ' + access_token } })
}

const requestAllManagerAssignedClientsNumber = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/assigned', { headers: { Authorization: 'Bearer ' + access_token } })
}

export default {
    signUpRequest,
    userListRequest,
    userRequest,
    userUpdateRequest,
    userDepositUpdateRequest,
    userSettingsUpdateRequest,
    userDetailsUpdateRequest,
    signUpRequestByAdmin,
    usersExportInExcelRequest,
    userUpdateByUserRequest,
    loginAsOtherUser,
    requestAllUsers,
    managerListRequest,
    salesStaffListRequest,
    requestAllManagerAssignedClientsNumber
}



// WEBPACK FOOTER //
// ./src/api/apiUsers.js